var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudRouter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Product Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 14v3l-5-5 5-5v3h3v4zM5 10H2v4h3v3l5-5-5-5zm9 7v-3h-4v3H7l5 5 5-5zm0-10v3h-4V7H7l5-5 5 5z",
    fill: "#4285f4",
    "data-name": "24 router"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNHB4IiBoZWlnaHQ9IjI0cHgiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM0Mjg1ZjQ7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5JY29uXzI0cHhfUm91dGVyX0NvbG9yPC90aXRsZT48ZyBkYXRhLW5hbWU9IlByb2R1Y3QgSWNvbnMiPjxnID48ZyA+PGcgZGF0YS1uYW1lPSIgMjQgcm91dGVyIj48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xOSwxNHYzbC01LTUsNS01djNoM3Y0Wk01LDEwSDJ2NEg1djNsNS01TDUsN1ptOSw3VjE0SDEwdjNIN2w1LDUsNS01Wk0xNCw3djNIMTBWN0g3bDUtNSw1LDVaIi8+PC9nPjwvZz48L2c+PC9nPjwvc3ZnPg==";
export { SvgCloudRouter as ReactComponent };